import { Button, ButtonProps, Card, CardActions, CardContent, Divider } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showModal } from '../../../../app/reducers';
import { OtherIndividualInfo } from '../../../../domain/person';
import { PersonReviewDetails } from '../person-review-details';

type Props = {
  individual: OtherIndividualInfo;
  handleEdit: (individual: OtherIndividualInfo) => void;
};
const OtherIndividualCard: React.FC<Props> = ({ individual, handleEdit }: Props) => {
  const dispatch = useDispatch();
  const removeHandler = useCallback(() => {
    dispatch(
      showModal({
        type: 'remove-other-individual',
        context: {
          uiId: individual.uiId,
        },
      }),
    );
  }, [dispatch, individual]);
  return (
    <Card variant="outlined">
      <CardContent>
        <PersonReviewDetails personalInfo={individual} includeOwnerInfo={true} includeControlInfo={true} />
      </CardContent>
      <Divider />
      <CardActions>
        <Button variant="text" size="large" fullWidth onClick={() => handleEdit(individual)}>
          Edit
        </Button>
        <Divider orientation="vertical" flexItem={true} />
        <Button variant="text" size="large" color={'danger' as ButtonProps['color']} fullWidth onClick={removeHandler}>
          Remove
        </Button>
      </CardActions>
    </Card>
  );
};

export { OtherIndividualCard };
